import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from 'src/components/Button';
import GenericDialogue from 'src/components/Dialogue/Dialogue';
import { selectAssetFormData } from 'src/store/selectors/assetForm';
import { selectFormLoader } from 'src/store/selectors/FormLoader';
import AssetForm from 'src/components/AssetForm/AssetForm';
import "./AddAssetDialogue.scss";

interface AddAssetDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSaveAsset: (data: any) => void;
  newAsset: boolean;
  propertyId: string;
  selectedAreaId?: string;
}

const AddAssetDialog = ({
  isOpen,
  onClose,
  onSaveAsset,
  newAsset,
  propertyId,
  selectedAreaId,
}: AddAssetDialogProps) => {
  const assetFormData: any = useSelector(selectAssetFormData);
  const loader: any = useSelector(selectFormLoader);

  const [buttonPressed, setButtonPressed] = useState('');

  const isSaveDisabled: boolean =
    (assetFormData.item && assetFormData.item.id
      ? !assetFormData.item.id
      : !assetFormData.itemId) ||
    (assetFormData.allRooms && assetFormData.allRooms === true
      ? !assetFormData.allRooms
      : !assetFormData.roomType);

  const handleSaveAndAdd = () => {
    setButtonPressed('SaveAndAdd');
    onSaveAsset(assetFormData);
  };

  const handleSaveAndClose = () => {
    setButtonPressed('SaveAndClose');
    onSaveAsset(assetFormData);
  };

  return (
    <GenericDialogue
      isOpen={isOpen}
      onClose={onClose}
      title={newAsset ? 'Add an Asset' : 'Edit an Asset'}
      maxWidth="100rem"
      maxHeight="95vh"
      footer={
        loader ? undefined : (
          <>
            {newAsset ? (
              <Button
                color="semantic"
                size="small"
                label="Save and Add Another"
                onClick={handleSaveAndAdd}
                disabled={isSaveDisabled || !assetFormData.dateOfPurchase}
              />
            ) : null}
            <Button
              color="teal"
              size="small"
              label="Save Asset"
              onClick={handleSaveAndClose}
              disabled={isSaveDisabled}
            />
          </>
        )
      }
    >
      <div className="dialog_body">
        <AssetForm
          propertyId={propertyId}
          onClose={onClose}
          newAsset={newAsset}
          selectedAreaId={selectedAreaId}
          buttonPressed={buttonPressed}
        />
      </div>
    </GenericDialogue>
  );
};

export default AddAssetDialog;